(() => {
  const forms = document.querySelectorAll('form.phaux-newsletter__form');
  if (!forms.length) return;

  /*
   * Footer / CTA newsletter forms.
   *
   * The store has reCAPTCHA on customer forms, so the submit must be NATIVE for
   * Shopify to attach the CAPTCHA token (an AJAX fetch is rejected with 400
   * "Missing CAPTCHA token"). Targeting a hidden iframe keeps the native submit
   * + token + customer record, but stops the main page from navigating - so the
   * URL stays clean (no ?customer_posted=true#...) and we show an inline
   * thank-you instead of a full reload.
   */
  let sink = document.querySelector('iframe[name="phaux-newsletter-sink"]');
  if (!sink) {
    sink = document.createElement('iframe');
    sink.name = 'phaux-newsletter-sink';
    sink.setAttribute('aria-hidden', 'true');
    sink.tabIndex = -1;
    sink.style.display = 'none';
    document.body.appendChild(sink);
  }

  forms.forEach((form) => {
    if (form.dataset.phauxEnhanced) return;
    form.dataset.phauxEnhanced = '1';
    form.setAttribute('target', 'phaux-newsletter-sink');

    const fields = form.querySelector('[data-newsletter-fields]');
    const success = form.querySelector('[data-newsletter-success]');

    form.addEventListener('submit', () => {
      /* Show thank-you immediately. Do NOT preventDefault: the native submit
         posts to the hidden iframe so reCAPTCHA still runs and the main page
         does not reload. */
      if (fields) fields.hidden = true;
      if (success) success.hidden = false;
    });
  });
})();
